import { RenaultFileDTO } from "./renault-file-dto";
import { DistributorParams } from "./shared-dto";

export class RenaultLeadDTO {
  IdLead: string | null;
  IdDistributor: string;
  SocialName: string;
  AccountNumber: string;
  IdSource: number;
  IdType: number;
  IdSubtype: number;
  IdBrand: number;
  Type: string;
  Subtype: string;
  Brand: string;
  Model: string;
  Mileage: string;
  Source: string;
  Status: string;
  IdStatus: string;
  ContactCallCenter: string;
  ContactPerson: string;
  CarLicencePlate: string;
  Chassis: string;
  DossierNumber: string | null;
  CreationDate: string;
  LateDate: Date;
  Name: string;
  Surname: string;
  Phone: string;
  Email: string;
  ContactReason: string;
  Provider: string;
  TimeStart: string;
  TimeEnd: string;
  AppointmentDate: string;
  CompanyName: string;
  ClientType: string;
  Operations: string;
  Messages: RenaultLeadMessageDTO[];
  SalesforceSubmissionResult: SalesforceSubmissionResultDTO;
}

export class RenaultLeadMessageDTO {
  IdMessage: string;
  IdLead: number;
  IdUser: number;
  StatusLead: string;
  IdStatusLead: number;
  User: string;
  Message: string;
  Result: string;
  Situation: string;
  File: RenaultFileDTO | null;
  CreationDate: string;
  PublishSince: string;
  canEdit: boolean;
  callCenter: boolean;
}

export class RenaultLeadMessagePostDTO {
  IdUser: string;
  IdLead: string | null;
  IdStatusLead: number;
  IdMessage: string;
  Message: string;
  Result: string;
  Situation: string;
  File: File | null;
}

export class RenaultLeadPostDTO {
  IdStatus: number;
  IdDistributor: number;
  IdType: number;
  IdSubtype: number;
  IdUser: number;
  IdSource: number;
  IdBrand: number;
  ContactPerson: string;
  CarLicencePlate: string;
  Chassis: string;
  DossierNumber: string;
  Name: string;
  Surname: string;
  Phone: string;
  Email: string;
  ContactReason: string;
  Model: string;
  Mileage: string;
  TimeStart: string;
  TimeEnd: string;
  AppointmentDate: string;
  CompanyName: string;
  ClientType: string;
  Operations: string;
  Messages: any[] = [];
}

export class RenaultLeadFilter {
  DistributorFilters: DistributorParams = new DistributorParams();
  IdType: number | null;
  IdSubtype: number | null;
  IdBrand: number | null;
  IdSource: number | null;
  IdDashboardSubtypePv: number | null;
  IdDashboardSubtypeRec: number | null;
  IdStatus: number | null;
  IdAgent: number | null;
  InitCreationDate: string | null;
  EndCreationDate: string | null;
  InitClosedDate: string | null;
  EndClosedDate: string | null;
  ImportLimit: number | null;
  ExportLimit: number | null;
  Year: number = new Date().getFullYear();
  Month: number | null;
}

export class RenaultLeadHighLights {
  StatusPv: RenaultLeadHighLightsStatus[];
  StatusReclamacion: RenaultLeadHighLightsStatus[];
  StatusLead_24_7: RenaultLeadHighLightsStatus[];
  TotalVnEnviado: number;
}

export class RenaultLeadHighLightsStatus {
  IdStatus: number;
  Status: string;
  Count: string;
}

export class RenaultLeadDashBoard {
  DashboardPV: RenaultLeadDashBoardType;
  DashboardReclamacion: RenaultLeadDashBoardType;
  DashboardLead_24_7: RenaultLeadDashBoardType;
  DashboardVN: RenaultLeadDashBoardVn;
}

export class RenaultLeadDashBoardVn {
  TotalEnviados: number;
  SolicitudPrueba: number;
  SolicitudPruebaPercent: number;
  SolicitudOfertaVn: number;
  SolicitudOfertaVnPercent: number;
  SolicitudOfertaVo: number;
  SolicitudOfertaVoPercent: number;
}

export class RenaultLeadDashBoardType {
  TotalClosedLeads: number;
  TotalClosedLeadsPercent: string;
  MediaInteractionLeads: string;
  MediaResponseTime: MediaResponseTime;
  Agents: RenaultLeadDashBoardAgents[];
  Distris: RenaultLeadDashBoardDistris[];
  ChartResponseTime: ChartsResponseTime;
  InternetLeadsTotal: number;
  InternetLeadsOnTime: number;
  InternetLeadsOutTime: number;
  InternetLeadsTreatedOnTime: number;
  InternetLeadsTreatedOutTime: number;
}

export class RenaultLeadDashBoardAgents {
  Name: string;
  TotalLeads: number;
}

export class RenaultLeadDashBoardDistris {
  Name: string;
  TotalLeads: number;
}
export class ChartsResponseTime {
  MonthList: string[];
  Time: (number | null)[];
}

export class MediaResponseTime {
  Hours: number;
  Minutes: number;
  Days: number;
}

export class LeadSubtypePermissionModel {
  IdType: number;
  IdSubtype: number;
  IdSubtypeGroup: number;
  IdPermission: number;
}

export class RenaultLeadDashBoardV16 {
  TotalLeads: number;
  NuevosLeads: number;
  Registros: number;
  ActivacionesBaliza: number;
  LeadsExportados: number;
  UltimaImportacion: string | null;
  UltimaExportacion: string | null;
  Chart: RenaultLeadDashBoardV16ChartDay[];
  Importaciones: RenaultLeadDashBoardV16ImportRow[];
  Exportaciones: RenaultLeadDashBoardV16ExportRow[];
  EstadoApi: boolean;
  EstadoCaptura: boolean;
  EstadoSftp: boolean | null;
}

export class RenaultLeadDashBoardV16ChartDay {
  Date: string;
  TotalLeads: number;
  Registros: number;
  ActivacionesBaliza: number;
}

export class RenaultLeadDashBoardV16ImportRow {
  CreationDate: string;
  Count: number;
}

export class RenaultLeadDashBoardV16ExportRow {
  Date: string;
  FileName: string;
  Count: number;
  IdStatus: number;
}

export class SalesforceSubmissionResultDTO {
  Success: boolean;
  StatusCode: number | null;
  ErrorMessage: string;
  RetryCount: number;
}